import React from 'react';
import {IForms} from '../../@interfaces/services/Forms/IForms';
import {StringArray} from '../../@interfaces/types';
import {IFormConfig} from '../../@interfaces/components/Form/IFormConfig';
import {FormContext} from '../../@types/components/Form';
import Form from '../../components/Form/Form';
import {AnySchema} from 'yup';
import app from '../../helpers/app';

export default class Forms implements IForms {
    protected formsConfigs: StringArray<IFormConfig> = {};

    getFormsConfigs(): StringArray<IFormConfig> {
        return this.formsConfigs;
    }

    setFormsConfigs(formsConfigs: StringArray<IFormConfig>): void {
        this.formsConfigs = formsConfigs;
    }

    getFormConfig(formName: string): IFormConfig | null {
        const configs = this.getFormsConfigs();

        return formName in configs ? configs[formName] : null;
    }

    getFormValidationScheme(config: IFormConfig): AnySchema {
        return app('scheme-builder').getSchemeByFormConfig(config);
    }

    render(formName: string, context?: FormContext): React.ReactNode | React.ReactNode[] {
        const config = this.getFormConfig(formName);
        if (!config) {
            return null;
        }

        return <Form
                formName={formName}
                config={config}
                context={context}
        />;
    }
}
